/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { conditionallyCreateMapObjectLiteral } from '@angular/compiler/src/render3/view/util';
import { AbstractControl, FormControl } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

/**
 *
 * @param control Control that has the validatior defined
 * @param form Complete form
 * @param options A validation function specific option object. Example:
 * @returns true if validation passed. An object with the validation id and a message property
 *  inside if failed. Example: { "date": { message: "Something went wrong"}}
 */


export function arrayRegexValidator(
  control: AbstractControl,
  form: FormlyFieldConfig,options: any = {},
) {
  const model = control.value;
  let errormsg = '';
  const numberContainer = form.props?.validInputs;
  let isMatch = false;
  if (!model) {
    return null;
  }
  if(numberContainer && numberContainer.length > 0){
    isMatch = numberContainer.some(function(rx) { return rx.match(model); });
    if(!isMatch){
        errormsg = "Please give a valid input";
    }
  }
  if(errormsg){
    return {
      relatedInputValidation: {
        message: errormsg,
      }
    };
  }else{
    return null;
    }
}


